import React, { useState } from "react";
import apiClient from "../api/apiClient";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "../css/LoginWithMpin.css";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [mobileNo, setMobileNo] = useState("");
  const [registerId, setRegisterId] = useState("");
  const [otpCode, setOtpCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);

  const handleSendOtp = async () => {
    if (mobileNo.length !== 10) {
      toast.warn("Please enter a valid 10-digit mobile number.");
      return;
    }

    setIsLoading(true);

    try {
      const res = await apiClient.post("/send-password-otp", { mobileNo });

      if (res.data.status === true) {
        setRegisterId(res.data.info || "");
        setOtpSent(true);
        toast.success(res.data.msg || "OTP sent successfully.");
      } else {
        toast.error(res.data.msg || "Failed to send OTP.");
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleResetPassword = async () => {
    if (!registerId) {
      toast.warn("Please request OTP first.");
      return;
    }

    if (!otpCode.trim() || !newPassword.trim() || !confirmPassword.trim()) {
      toast.warn("Please fill all fields.");
      return;
    }

    if (newPassword.length < 8 || newPassword.length > 15) {
      toast.warn("Password must be 8 to 15 characters long.");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    setIsLoading(true);

    try {
      const res = await apiClient.post("/reset-password", {
        registerId,
        otpCode,
        newPassword,
        confirmPassword,
      });

      if (res.data.status === true) {
        localStorage.setItem("mobileNo", mobileNo);
        localStorage.setItem("lastLoginMobileNo", mobileNo);
        toast.success("Password updated successfully.");
        navigate("/login-with-mpin", { replace: true });
      } else {
        toast.error(res.data.msg || "Failed to reset password.");
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mainhome-screen-wrapper">
      <div className="top-header">Reset Password</div>
      <div className="mpin-container" style={{ justifyContent: "flex-start", paddingTop: "60px" }}>
        <div className="mpin-card" style={{ boxShadow: "0 8px 32px rgba(0,0,0,0.08)", border: "1px solid #f0f0f0" }}>
          <h2 style={{ fontSize: "22px", color: "#121212", marginBottom: "30px" }}>Reset Password</h2>

          <div className="input-group" style={{ width: "100%", marginBottom: "20px" }}>
            <input
              type="text"
              placeholder="Enter Mobile Number"
              className="mpin-input"
              style={{ textAlign: "center", fontSize: "18px" }}
              value={mobileNo}
              maxLength={10}
              disabled={otpSent}
              onChange={(e) => setMobileNo(e.target.value.replace(/\D/g, "").slice(0, 10))}
            />
          </div>

          {otpSent && (
            <>
              <div className="input-group" style={{ width: "100%", marginBottom: "20px" }}>
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength={6}
                  placeholder="Enter OTP"
                  className="mpin-input"
                  style={{ textAlign: "center", fontSize: "18px" }}
                  value={otpCode}
                  onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
                />
              </div>

              <div className="input-group" style={{ width: "100%", marginBottom: "20px" }}>
                <input
                  type="password"
                  placeholder="Enter New Password"
                  className="mpin-input"
                  style={{ textAlign: "center", fontSize: "18px" }}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>

              <div className="input-group" style={{ width: "100%", marginBottom: "20px" }}>
                <input
                  type="password"
                  placeholder="Confirm New Password"
                  className="mpin-input"
                  style={{ textAlign: "center", fontSize: "18px" }}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
            </>
          )}

          <button
            className="mpin-login-btn"
            onClick={otpSent ? handleResetPassword : handleSendOtp}
            disabled={isLoading}
          >
            {isLoading
              ? otpSent
                ? "RESETTING..."
                : "SENDING..."
              : otpSent
                ? "RESET PASSWORD"
                : "SEND OTP"}
          </button>
        </div>
      </div>
    </div>
  );
}
